<template>
    <div class="accept-contest">
        <MobileWait v-if=" ! contest"/>
        <template v-else>
            <div class="crumbs">
                <router-link :to="{ name: 'contests' }">Конкурсы</router-link>
                <span>/</span>
                <router-link
                    :to="{ name: 'contest', params: { id: contest.id } }"
                >{{ contest.title }}</router-link>
            </div>

            <h1>Мои данные</h1>

            <img :src="contest.img" alt="Логотип">

            <h1>{{ contest.title }}</h1>

            <a
                :href="contest.link"
                class="contest-link"
            >{{ contest.link }}</a>

            <div class="button more-details">Подробнее</div>

            <h2>Заполните данные для регистрации</h2>

            <p class="subtitle">Для завершения регистрации заполните
                недостающие данные</p>

            <div class="form">
                <input
                    type="text"
                    placeholder="Имя"
                    v-model="form.firstName"
                >
                <input
                    type="text"
                    placeholder="Фамилия"
                    :data-voicetext="form.lastName"
                    v-model="form.lastName"
                >
                <input
                    type="text"
                    placeholder="Возраст"
                >
                <input
                    type="text"
                    placeholder="Специальность"
                >
            </div>

            <div
                class="button participate"
                @click="showPopup(success)"
            >Участвовать в конкурсе</div>

            <div
                class="button save-draft"
                @click="showPopup(error)"
            >Сохранить черновик</div>
        </template>
    </div>
</template>

<script>
import MobileWait from '../MobileWait';

import { mapActions } from 'vuex';

const actions = [
    'showPopup',
];

export default {
    name: 'MobileAcceptContest',
    props: {
        contest: Object,
        user: Object,
    },
    data() {
        const name = this.user.name.split(' ');

        return {
            form: {
                firstName: name[0],
                lastName: name[1],
                age: null,
                prof: null,
            },

            success: {
                success: true,
                title: 'Вы зарегистрированы!',
                text: 'Смотрите подробности в разделе «Конкурсы»',
                button: 'Понятно',
                color: '#4663AB',
            },

            error: {
                title: 'Произошла ошибка!',
                text: 'Это пример сообщения об ошибке',
                button: 'Понятно',
                color: '#D1004A',
            },
        };
    },
    methods: {
        ...mapActions(actions),
    },
    components: {
        MobileWait,
    },
    watch: {
        user(value) {
            if ( ! value.id)
                window.location = process.env.VUE_APP_AUTH;

            const name = value.name.split(' ');

            this.form.firstName = name[0];
            this.form.lastName = name[1];
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '../../styles/rem';
    /*activate checkbox regExp in finder of phpStorm*/
    /*find      {: ([0-9]*)px}*/
    /*replace   {: rem($1);}*/

    .accept-contest {
        padding: rem(50) 5rem 5rem;
        min-height: 100rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .crumbs {
        margin-top: 2.9rem;

        * {
            font-size: 2.9rem;
            color: #98A0A9;
        }

        span {
            margin: 0 2rem;
        }
    }

    h1 {
        font-size: 5rem;
    }

    img {
        width: 90rem;
        height: 60rem;
        border-radius: 2rem;
        margin: 5rem 0 2rem;
    }

    .contest-link {
        font-size: 2.9rem;
        color: #0465AC;
    }

    .button {
        margin-top: 3.5rem;
        font-size: 3.5rem;
        font-weight: bold;
        height: 10rem;
        width: 100%;
        border-radius: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .more-details {
        background-color: #fff;
        border: solid 1px #63B5E6;
        color: #4663AB;
    }

    h2 {
        color: #EFB762;
        font-size: 5rem;
        margin-bottom: 0;
    }

    .subtitle {
        font-size: 2.9rem;
    }

    input {
        width: 100%;
        height: 10rem;
        margin-bottom: 3rem;
        border: rem(1) solid #BAC5CB;
        border-radius: 2rem;
        padding-left: 3rem;
    }

    .participate {
        background-color: #D1004A;
        color: #fff;
    }

    .save-draft {
        background-color: #4663AB;
        color: #fff;
    }
</style>
